import { v4 as uuidv4 } from 'uuid'
import { isProduction } from '../config/configuration'

export const generateUID = () => {
  return uuidv4()
}

export const addTMXScriptToBody = (TMX_ID) => {
  const tmxOrgIdJ = isProduction() ? '51pz0o4y' : '9uviz06v'

  let tmxScriptUrl = `https://ocs.ameriprise.com/fp/tags.js?org_id=${tmxOrgIdJ}&session_id=${TMX_ID}`

  const script = document.createElement('script')
  script.src = tmxScriptUrl
  script.type = 'text/javascript'

  document.head.appendChild(script)
}
